const Index = () => import("./index");
const QuaterlyTaxes = () => import("./QuaterlyTaxes.vue");

export default [{
  path: "quarterlyTaxes",
  name: "quaterly-report",
  component: Index,
  redirect: {
    name: "quaterlyTaxes",
  },
  children: [{
    path: "date",
    name: "quaterlyTaxes",
    component: QuaterlyTaxes,
  }],
},
]
